import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { analytics } from '../../../../core/Constants';
import { OffersCardTile } from './OffersCardTile';
import { formatPhoneNumber } from '../../../../common/utils/CardUtils';

const RHLink = '/myaccount/proXtraRewards?drawerList=offer';

export const PreferredUnlocked = () => {
  return (
    <OffersCardTile
      imageURL="WelcomeCard/active_Preferred_Pricing.svg"
      imageClass="sui-pt-1"
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Preferred_Pricing_Unlocked}
      analyticsLinks={analytics.ANALYTICS_LINKS.LEARN_MORE}
      refLink="/myaccount/proXtraPricing"
      altText="Preferred Unlocked"
      linkText="Learn More"
    >
      <Typography variant="body-base" weight="bold" height="normal">
        Preferred Pricing Unlocked
      </Typography>
    </OffersCardTile>
  );
};

export const EliteSupportLine = ({ phoneTag }) => {
  const { value } = phoneTag;
  const phoneNumberFormatted = formatPhoneNumber(value);
  return (
    <OffersCardTile
      imageURL="WelcomeCard/active_ESL.svg"
      imageClass="sui-pt-1"
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Elite_Support_Line}
      analyticsLinks={analytics.ANALYTICS_LINKS.CONTACT}
      refLink={`tel:${value}`}
      altText="Elite Support Line"
      linkText={phoneNumberFormatted}
    >
      <Typography variant="body-base" weight="bold" height="normal">
        Contact Elite Support Line
      </Typography>
    </OffersCardTile>
  );
};

export const ExpiringOffers = ({ expiringOffersCount }) => {
  return (
    <OffersCardTile
      imageURL="WelcomeCard/active_offers.svg"
      imageClass="sui-pt-1"
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Offers_Expiring_Soon}
      analyticsLinks={analytics.ANALYTICS_LINKS.VIEW_OFFERS}
      refLink={RHLink}
      altText="Expiring Offers"
      linkText="View Your Offers"
    >
      <Typography variant="body-base" weight="bold" height="normal">
        {`${expiringOffersCount} Offers Expiring Soon`}
      </Typography>
    </OffersCardTile>
  );
};

export const AvailableOffers = ({ availableOffersCount }) => {
  return (
    <OffersCardTile
      imageURL="WelcomeCard/active_offers.svg"
      imageClass="sui-pt-1"
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Offers_Available}
      analyticsLinks={analytics.ANALYTICS_LINKS.VIEW_OFFERS}
      refLink={RHLink}
      altText="Available Offers"
      linkText="View Your Offers"
    >
      <Typography variant="body-base" weight="bold" height="normal">
        {`${availableOffersCount || 0} Offers Available`}
      </Typography>
    </OffersCardTile>
  );
};

export const PaintMemberProducts = ({ currentPaintLevel }) => {
  let paintImage;
  let paintLabel = '';
  let paintSublabel = '';

  if (currentPaintLevel === 'Bronze') {
    paintImage = 'WelcomeCard/paint_Bronze.svg';
    paintLabel = 'Save Up To 10% On Paint Products';
  } else if (currentPaintLevel === 'Silver') {
    paintImage = 'WelcomeCard/paint_Silver.svg';
    paintLabel = 'Save Up To 15% On Paint Products';
  } else if (currentPaintLevel === 'Gold') {
    paintImage = 'WelcomeCard/paint_Gold.svg';
    paintLabel = 'Save Up To 20% On Paint Products';
  } else {
    paintImage = 'WelcomeCard/paint_Member.svg';
    paintLabel = 'Save Up To 20%';
    paintSublabel = 'After Qualifying Spend';
  }
  return (
    <OffersCardTile
      imageURL={paintImage}
      imageClass="sui-pt-1"
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Paint_Rewards}
      analyticsLinks={analytics.ANALYTICS_LINKS.VIEW_PAINT}
      refLink="/myaccount/proXtraRewards"
      altText="Paint Offer Icon"
      linkText="View Paint Rewards"
    >
      <Typography variant="body-base" weight="bold" height="normal">
        {paintLabel}
      </Typography>
      {!!paintSublabel && (
        <Typography variant="body-base" weight="regular" height="normal">
          {paintSublabel}
        </Typography>
      )}
    </OffersCardTile>
  );
};
